import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchOrderById } from '../../../../store/orders/orderReducer';
import Spinner from '../../../../components/Spinner/Index';

const ViewOrders = () => {
    const { orderId } = useParams();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const { order, isLoading, isError, message } = useSelector((state) => state.orders);

    useEffect(() => {
        if (orderId && token) {
            dispatch(fetchOrderById({ orderId, token }));
        }
    }, [dispatch, orderId, token]);

    if (isLoading) return <Spinner />;
    if (isError) return <div className="text-red-500 text-center">{message}</div>;
    if (!order) return null;

    return (
        <div className="space-y-6 p-6 bg-gray-50">
            {/* General Order Summary */}
            <div className="bg-white shadow sm:rounded-lg">
                <div className="px-4 py-6 sm:px-6">
                    <h3 className="text-lg font-semibold text-gray-900">Order Summary</h3>
                </div>
                <div className="border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-900">Order ID</dt>
                            <dd className="mt-1 text-sm text-gray-700">{order._id}</dd>
                        </div>
                        <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-900">Total Amount</dt>
                            <dd className="mt-1 text-sm text-gray-700">${order.totalAmount.toFixed(2)}</dd>
                        </div>
                        <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-900">Payment Status</dt>
                            <dd className="mt-1 text-sm text-gray-700">{order.paymentStatus}</dd>
                        </div>
                        <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-900">Payment Method</dt>
                            <dd className="mt-1 text-sm text-gray-700">
                                {order.paymentMethod?.toUpperCase() || 'N/A'}
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>

            {/* Items Section */}
            {order.items.map((item, index) => {
                const business = item.businessId?.businessInformation || {};

                return (
                    <div key={index} className="bg-white shadow sm:rounded-lg">
                        <div className="px-4 py-6 sm:px-6">
                            <h3 className="text-lg font-semibold text-gray-900">Item Details</h3>
                        </div>
                        <div className="border-t border-gray-100">
                            <dl className="divide-y divide-gray-100">
                                {/* Product Details */}
                                <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium text-gray-900">Product</dt>
                                    <dd className="mt-1 text-sm text-gray-700">
                                        <div className="flex items-center space-x-4">
                                            <img
                                                src={`/public/${item.product.image_url}`}
                                                alt={item.product.name}
                                                className="h-16 w-16 rounded-md object-cover"
                                            />
                                            <div>
                                                <p className="font-bold text-gray-900">{item.product.name}</p>
                                                <p className="text-sm text-gray-500">Package: {item.packageName}</p>
                                                <p className="text-sm text-gray-500">Quantity: {item.quantity}</p>
                                                <p className="text-sm text-gray-900">Price: ${item.packagePrice}</p>
                                            </div>
                                        </div>
                                    </dd>
                                </div>

                                {/* Business Details */}
                                <div className="px-4 py-4 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium text-gray-900">Business</dt>
                                    <dd className="mt-1 text-sm text-gray-700">
                                        <p><strong>Name:</strong> {business.businessName || 'N/A'}</p>
                                        <p><strong>Email:</strong> {business.businessEmail || 'N/A'}</p>
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ViewOrders;
